module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "head2"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/half1.jpg"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("ILLUSTRATIONS")])])]), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_c('p', {
    staticClass: "head3"
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("APS")])])]), _c('p', {
    staticClass: "hang-a"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('a', {
    attrs: {
      "href": "#/map#map1"
    }
  }, [_c('i', [_vm._v("Map 1")]), _vm._v(" "), _c('b', [_vm._v("■")]), _vm._v(" Justinian’s empire, ca. 565 "), _c('i', [_vm._v("xvi")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('a', {
    attrs: {
      "href": "#/map#map2"
    }
  }, [_c('i', [_vm._v("Map 2")]), _vm._v(" "), _c('b', [_vm._v("■")]), _vm._v(" The Byzantine empire, ca. 1025 "), _c('i', [_vm._v("xvii")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('a', {
    attrs: {
      "href": "#/map#map3"
    }
  }, [_c('i', [_vm._v("Map 3")]), _vm._v(" "), _c('b', [_vm._v("■")]), _vm._v(" Byzantium, ca. 1350 "), _c('i', [_vm._v("xviii")])])]), _vm._v(" "), _c('p', {
    staticClass: "head3"
  }, [_vm._v("F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGURES")])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('a', {
    attrs: {
      "href": "#/ch01#ch1fig1"
    }
  }, [_c('i', [_vm._v("Figure 1")]), _vm._v(" "), _c('b', [_vm._v("■")]), _vm._v(" David Talbot Rice and Mark Ogilvie-Grant on their expedition to Mount Athos with Robert Byron "), _c('i', [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('a', {
    attrs: {
      "href": "#/ch01#ch1fig2"
    }
  }, [_c('i', [_vm._v("Figure 2")]), _vm._v(" "), _c('b', [_vm._v("■")]), _vm._v(" Watercolor of Mount Athos by Edward Lear "), _c('i', [_vm._v("19")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#ch2fig3",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Figure 3")]), _vm._v(" "), _c('b', [_vm._v("■")]), _vm._v(" The cathedral of St. Sophia at Ohrid "), _c('i', [_vm._v("37")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    attrs: {
      "href": "#/ch02#ch2fig4",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Figure 4")]), _vm._v(" "), _c('b', [_vm._v("■")]), _vm._v(" Ivory comb with jousting scene, tenth century "), _c('i', [_vm._v("43")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    attrs: {
      "href": "#/ch03#ch3fig5",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Figure 5")]), _vm._v(" "), _c('b', [_vm._v("■")]), _vm._v(" The Parthenon "), _c('i', [_vm._v("51")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _c('span', {
    attrs: {
      "href": "#/ch03#ch3fig6",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Figure 6")]), _vm._v(" "), _c('b', [_vm._v("■")]), _vm._v(" The ruins of Mistra in the Peloponnese "), _c('i', [_vm._v("61")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#ch4fig7",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Figure 7")]), _vm._v(" "), _c('b', [_vm._v("■")]), _vm._v(" Icon of the Archangel Michael, tenth century "), _c('i', [_vm._v("72")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    attrs: {
      "href": "#/ch04#ch4fig8",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Figure 8")]), _vm._v(" "), _c('b', [_vm._v("■")]), _vm._v(" Male dancers on the lid of a bone casket "), _c('i', [_vm._v("81")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#ch5fig9",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Figure 9")]), _vm._v(" "), _c('b', [_vm._v("■")]), _vm._v(" Icon "), _c('i', [_vm._v("The Triumph of Orthodoxy")]), _vm._v(", ca. 1400 "), _c('i', [_vm._v("91")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#ch5fig10",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Figure 10")]), _vm._v(" "), _c('b', [_vm._v("■")]), _vm._v(" Chrysobull issued in 1342 by the emperor John V Palaeologus "), _c('i', [_vm._v("104")])])]), _vm._v(" "), _c('p', {
    staticClass: "hang-a"
  }, [_c('span', {
    attrs: {
      "href": "#/ch05#ch5fig11",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Figure 11")]), _vm._v(" "), _c('b', [_vm._v("■")]), _vm._v(" Emperor John VI Cantacuzenus (1347–54) surrounded by bishops at the council of 1351 "), _c('i', [_vm._v("107")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4770eb75","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/list.vue
// module id = 78
// module chunks = 0